import React from "react"
import { graphql } from "gatsby"

import IndustryPageTemplate from "../../components/industries/IndustryPageTemplate"
import buildData from "../../data/industries/healthcare"

const Healthcare = ({ data }) => (
  <IndustryPageTemplate
    data={buildData({
      heroImage: data.heroImage?.childImageSharp?.gatsbyImageData,
      challengeImages: [
        data.challenge1?.childImageSharp?.gatsbyImageData,
        data.challenge2?.childImageSharp?.gatsbyImageData,
        data.challenge3?.childImageSharp?.gatsbyImageData,
        data.challenge4?.childImageSharp?.gatsbyImageData,
      ],
      solutionImage: data.solutionImage?.childImageSharp?.gatsbyImageData,
      resultsImage: data.resultsImage?.childImageSharp?.gatsbyImageData,
    })}
  />
)

export default Healthcare

export const query = graphql`
  query HealthcareIndustryImages {
    heroImage: file(relativePath: { eq: "industries/healthcare-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], breakpoints: [750, 1080, 1366, 1920, 2400], quality: 80)
      }
    }
    challenge1: file(relativePath: { eq: "industries/healthcare-challenge-1.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    challenge2: file(relativePath: { eq: "industries/healthcare-challenge-2.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    challenge3: file(relativePath: { eq: "industries/healthcare-challenge-3.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    challenge4: file(relativePath: { eq: "industries/healthcare-challenge-4.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    solutionImage: file(relativePath: { eq: "industries/healthcare-solution.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    resultsImage: file(relativePath: { eq: "industries/healthcare-results.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
  }
`
